import { useState } from 'react';
import { useFormContext } from 'react-hook-form';
import { getCvSourceSuggestions, ISourceSuggestion } from 'wisestep-api';
import { WsAutoComplete } from 'wisestep-base';

import WsFilterProps from '../../../../components/filters/models/WsFilterProps';

const SpreadSheetSource = ({ name }: WsFilterProps) => {
  const [sources, setSources] = useState<string[]>([]);
  const { setValue } = useFormContext();
  const onSourceNameInputKey = async (source: string) => {
    const response = await getCvSourceSuggestions(source);
    const result: ISourceSuggestion[] = response.data;
    setSources(result.map((source) => source.source));
  };
  const onSourceNameSelection = (SourceNames: string[]) => setValue(name, SourceNames[0]);
  return (
    <WsAutoComplete
      size="small"
      onValueEnter={onSourceNameInputKey}
      onTagsChange={onSourceNameSelection}
      placeholder="Add by source"
      initialValue={[]}
      optionsInStringArray={sources}
      multiple={false}
      freeSolo={true}
      name={name}
    />
  );
};
export default SpreadSheetSource;
